export default __webpack_public_path__ + "static/media/fa-regular-400.b7df56f4.svg";